import {css} from '@emotion/react'
import styled from '@emotion/styled'
import {media, colors, type} from '../styles'

const Button = styled.button`
    background-color: black;
    color: ${colors.red};
    text-transform: uppercase;
    border: 1px solid white;
    box-shadow: 6px 6px 0px ${colors.red};
    margin-bottom: 6px;
    transition: all 0.3s ease-in-out;
    font-family: ${type.larish};
    padding: 0.4rem 1rem;
    font-size: 1rem;
    cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAA9CAYAAAAu7nDIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEWSURBVHgB7ZmLDoMgDEVx2f9/MgwUyEJ4tqVR25MYExV31x3K5oxRFEVhxcWNjY+5McfCtQ4xFsStK6fhoGCcuw666/DhMcTIqFy+IWEF3z0hQqE26HbybufyyQ3uyWjCO9yT4Vy+iNA9WQs/pXuynMsXE7gn88smhXsyncuDEO5tr1wIVwacZXvl8mDAbw32JuxDHmEzE3wNMdbac98JaON+GBATzvVehGIJw4RLSlRdTBXEAAlH8hgseecr3LwfJBzVJBq6txKu+g6TW6lV/LWM1vhpGdHWupimDNNaGVxxotf3yFvJBNPOsofzhZp2Vh8eQqH4WEcOpYkw7GvVgTtZmZ0l6hwUDQeFowmz/pmnKIryJH73rFhzd/HvQQAAAABJRU5ErkJggg==),
        auto;

    ${media(
        900,
        css`
            padding: 0.6rem 2rem;
            /* font-size: 1.2rem; */
        `
    )}

    &:hover {
        box-shadow: 2px 2px 0px ${colors.red};
        background-color: white;
        color: black;
        border-color: black;
    }
`
export default Button
